import { render, staticRenderFns } from "./Adsense.vue?vue&type=template&id=0a8a92e4&scoped=true"
import script from "./Adsense.vue?vue&type=script&lang=js"
export * from "./Adsense.vue?vue&type=script&lang=js"
import style0 from "./Adsense.vue?vue&type=style&index=0&id=0a8a92e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a92e4",
  null
  
)

export default component.exports